





























































// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import { useTranslate } from "@/plugins/translate";

const getBoolProp = (d: boolean = false) => ({ type: Boolean, default: d });

export default defineComponent({
	emits: ["previous", "next"],
	props: {
		hasPrevious: getBoolProp(true),
		hasNext: getBoolProp(true),
		showPrevious: getBoolProp(false),
		showNext: getBoolProp(true),
		canContinue: getBoolProp(true),
	},
	setup(props, context) {
		const open = ref(true);

		const previous = () => context.emit("previous");
		const next = () => context.emit("next");
		
		const { translate } = useTranslate(context);

		const getPhraseTooltip = (phraseKey:string, variant:string = "dark") => {

			const title = translate(phraseKey).toUpperCase();

			return {
				title,
				interactive:true,
				delay:0,
				animation:false,
				variant,
				customClass:"font-weight-light"
			};
		};

		return {
			open,
			previous,
			next,
			getPhraseTooltip,
		};
	},
});
